import React from 'react';
import media from '@/data/service-media.json';

// AI-generated service scenes and workflow maps (SMI Redesign v5, approved 2026-09-30).
// Every scene carries a visible "AI-generated illustration" caption.
export const mediaFor = slug => media.offers[slug] || null;

export const ServiceImage = ({slug, prefix = 'service', sizes = '(max-width: 700px) calc(100vw - 40px), 640px', decorative = false, eager = false}) => {
  const m = mediaFor(slug);
  if (!m) return null;
  return <figure className="signal-media" data-testid={`${prefix}-media-${slug}`}>
    <img src={`${m.image}-800.webp`} srcSet={`${m.image}-800.webp 800w, ${m.image}-1600.webp 1600w`} sizes={sizes}
      width={m.w} height={m.h} alt={decorative ? '' : m.alt} loading={eager ? 'eager' : 'lazy'} decoding="async" data-testid={`${prefix}-image-${slug}`}/>
    <figcaption data-testid={`${prefix}-caption-${slug}`}>AI-generated illustration</figcaption>
  </figure>;
};

export const ServiceMap = ({slug, name, prefix = 'service'}) => {
  const m = mediaFor(slug);
  if (!m?.map) return null;
  return <figure className="signal-map" data-testid={`${prefix}-map-${slug}`}>
    <img src={m.map} alt={`${name} workflow map. The same steps are listed below.`} width="1200" height="740" loading="lazy" decoding="async"/>
  </figure>;
};
